import { inject, Service } from '@angular/core';
import { MadCloudResult } from '@common/http/models/mad-cloud-result.model';
import { PageFilter } from '@common/paged-data/types/page-filter.type';
import { Page } from '@common/paged-data/types/page.type';
import { CollectionServiceBase } from '@portal-core/data/collection/services/collection.service.base';
import { CreateStatusIncident } from '@portal-core/status-incidents/models/status-incident-create.model';
import { StatusIncidentUpdate } from '@portal-core/status-incidents/models/status-incident-update.model';
import { StatusIncident } from '@portal-core/status-incidents/models/status-incident.model';
import { StatusIncidentsApiService } from '@portal-core/status-incidents/services/status-incidents-api.service';
import { StatusIncidentsDataService } from '@portal-core/status-incidents/services/status-incidents-data.service';
import { Observable } from 'rxjs';

@Service()
export class StatusIncidentsService extends CollectionServiceBase<StatusIncident> {
  private readonly statusIncidentsApiService = inject(StatusIncidentsApiService);

  constructor() {
    super(inject(StatusIncidentsDataService));
  }

  getActiveStatusIncident$(): Observable<StatusIncident> {
    return this.statusIncidentsApiService.getActiveStatusIncident$();
  }

  getActiveStatusIncidentAdmin$(): Observable<StatusIncident> {
    return this.statusIncidentsApiService.getActiveStatusIncidentAdmin$();
  }

  getStatusIncidentsHistoryPage$(filter: PageFilter): Observable<Page<StatusIncident>> {
    return this.statusIncidentsApiService.getStatusIncidentsHistoryPage$(filter);
  }

  createStatusIncident$(incident: CreateStatusIncident): Observable<StatusIncident> {
    return this.statusIncidentsApiService.createStatusIncident$(incident);
  }

  deactivateStatusIncidents$(): Observable<MadCloudResult> {
    return this.statusIncidentsApiService.deactivateStatusIncidents$();
  }

  publishStatusIncident$(incidentId: number): Observable<StatusIncident> {
    return this.statusIncidentsApiService.publishStatusIncident$(incidentId);
  }

  unpublishStatusIncident$(incidentId: number): Observable<StatusIncident> {
    return this.statusIncidentsApiService.unpublishStatusIncident$(incidentId);
  }

  updateStatusIncident$(incidentId: number, incident: StatusIncident): Observable<StatusIncident> {
    return this.statusIncidentsApiService.updateStatusIncident$(incidentId, incident);
  }

  deleteStatusIncidentById$(incident: StatusIncident): Observable<MadCloudResult> {
    return this.statusIncidentsApiService.deleteStatusIncidentById$(incident);
  }

  addStatusIncidentUpdate$(incidentId: number, update: Partial<StatusIncidentUpdate>): Observable<StatusIncidentUpdate> {
    return this.statusIncidentsApiService.addStatusIncidentUpdate$(incidentId, update);
  }

  updateStatusIncidentUpdate$(incidentId: number, update: StatusIncidentUpdate): Observable<StatusIncidentUpdate> {
    return this.statusIncidentsApiService.updateStatusIncidentUpdate$(incidentId, update);
  }

  deleteStatusIncidentUpdate$(incidentId: number, updateId: number): Observable<MadCloudResult> {
    return this.statusIncidentsApiService.deleteStatusIncidentUpdate$(incidentId, updateId);
  }
}
